<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.fullName">
    <div class="text-right leading-tight hidden sm:block">
      <vs-chip class="mt-1 mr-3">
        <small>{{userPackage}} Edition</small>
      </vs-chip>
      <vs-chip class="mt-1 mr-3" color="dark">
        <small>Remaining Simulations: {{activeUserInfo.remainingSimulationCount === -1 ? 'unlimited' : activeUserInfo.remainingSimulationCount}}</small>
      </vs-chip>
    </div>
    <div class="text-center leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.fullName }}</p>
      <small>{{activeUserInfo.userType}}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          key="onlineImg"
          :src="activeUserInfo.photoURL === null || activeUserInfo.photoURL === undefined ? require('@/assets/images/portrait/small/avatar.svg') : getImage(activeUserInfo.photoURL)"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/profile')"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/tickets')"
          >
            <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tickets</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/packages')"
          >
            <feather-icon icon="CreditCardIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Packages</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userPackage: "",
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    getImage(image_id) {
      return `${process.env.VUE_APP_BASE_URL}/images/${image_id}`;
    },
    logout() {
      this.$http
        .get("/auth/logout")
        .then((res) => {
          if (res.data && res.data.status === true) {
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          this.$router.push("/login");
        });
    },
  },
  created() {
    this.$http.get("/user/profile").then((res) => {
      if (res.data.status === true) {
        this.userPackage = res.data.user.packageType.title;
      }
    });
  },
};
</script>
